import Analytics from './analytics';

export default class AnalyticsLogger {
  /**
   * INIT/CONFIG FUNCTIONS
   */
  constructor(config) {
    //TODO: refactor analytics so it's either in the state tree or globally accessible
    if(!this.analytics) {
      this.analytics = new Analytics(config);
    }
    this.isMobile = config.isMobile;
    this.closeoutType = null;

    this.logCloseoutDocumentEvent = this.logCloseoutDocumentEvent.bind(this);
  }

  setUserRole(role) {
    this.analytics.currentRole = role;
  }
  
  /**
   * TASK LOGGING FUNCTIONS
   */
  logApprovalEvent() {
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.event('TaskCompletionStep', eventAction, 'CompletionStepApproved');
  }

  logBuildOwnerUpdateEvent(isExistingBuild) {
    const eventLabel = isExistingBuild ? 'BuildOwnerReAssigned' : 'BuildOwnerAssigned';
    this.analytics.event('BuildOwnerAssignment', 'BuildOwner', eventLabel);
  }

  logCheckoffEvent() {
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.event('TaskCompletionStep', eventAction, 'CompletionStepCheckedOff');
  }

  logGenericCSEvent(label) {
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.event('TaskCompletionStep', eventAction, label);
  }

  logNotApplicable(label, fileType) {
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    if (fileType) {
      const customDimensions = {
        'dimension4': fileType,
      };
      this.analytics.eventWithCustomDimensions('TaskCompletionStep', eventAction, label, null, customDimensions);
    }
    else {
      this.analytics.event('TaskCompletionStep', eventAction, label);
    }
  }

  logRejectionEvent() {
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.event('TaskCompletionStep', eventAction, 'CompletionStepRejected');
  }

  logReviewEvent() {
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.event('TaskCompletionStep', eventAction, 'CompletionStepReviewed');
  }

  logReversalEvent() {
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.event('TaskCompletionStep', eventAction, 'CompletionStepReversal');
  }

  logInspectionEvent(inspectionType) {
    let inspection;
    switch(inspectionType){
    case 'YES':
      inspection = 'CompletionStepInspectionCheck';
      break;
    case 'N/A':
      inspection = 'CompletionStepInspectionNA';
      break;
    case 'NO':
      inspection = 'CompletionStepInspectionX';
      break;
    default:
      break;
    }
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.event('TaskCompletionStep', eventAction, inspection);
  }

  logFormSubmitEvent() {
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.event('TaskCompletionStep', eventAction, 'CompletionStepFormSubmit');
  }

  logStepCreate(label) {
    // label params: 'CompletionStepInspectionAdded', 'CompletionStepFormAdded'
    this.analytics.event('TaskCompletionStep', 'CompletionStep - Web', label);
  }

  /**
  * @param { String } fileType - extension of the file being uploaded ((Doc, PDF, Xls, Mp4, Other), maps to 'dimension4' in gA
  */
  logUploadEvent(fileType) {
    const customDimensions = {
      'dimension4': fileType,
    };
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.eventWithCustomDimensions('TaskCompletionStep', eventAction, 'CompletionStepUpload', null, customDimensions);
  }

  /**
   * DOCUMENT LOGGING FUNCTIONS
   */

  /**
  * @param { String } fileType - extension of the file being uploaded ((Doc, PDF, Xls, Mp4, Other), maps to 'dimension4' in gA
  * @param { label } string - DocumentLibraryRDViewed, ProjectDetailsUDViewed, TaskDetailsUDViewed, ProjectDetailsRDViewed, TaskDetailsRDViewed
  */
  logRDLDownloadEvent(fileType, label) {
    const customDimensions = {
      'dimension4': fileType,
    };

    const eventAction = !!this.isMobile ? 'ReferenceDocuments - Mobile' : 'ReferenceDocuments - Web';
    
    this.analytics.eventWithCustomDimensions('Documents', eventAction, label, null, customDimensions);
  }

    /**
  * @param { String } fileType - extension of the file being uploaded ((Doc, PDF, Xls, Mp4, Other), maps to 'dimension4' in gA
  * @param { label } string - DocumentLibraryRDViewed, ProjectDetailsUDViewed, TaskDetailsUDViewed, ProjectDetailsRDViewed, TaskDetailsRDViewed
  */
  logUniqueDocDownloadEvent(fileType, label) {
    const customDimensions = {
      'dimension4': fileType,
    };

    const eventAction = !!this.isMobile ? 'UniqueDocuments - Mobile' : 'UniqueDocuments - Web';
  
    this.analytics.eventWithCustomDimensions('Documents', eventAction, label, null, customDimensions);
  }

  logRDLSwapEvent(fileType) {
    const customDimensions = {
      'dimension4': fileType,
    };
    this.analytics.eventWithCustomDimensions('Documents', 'ReferenceDocuments - Web', 'ReferenceDocumentSwap', null, customDimensions);
  }

  logRDLUploadEvent(fileType, isUploadToLibrary) {
    const customDimensions = {
      'dimension4': fileType,
    };

    const label = isUploadToLibrary ? 'RDLibraryUpload' : 'ReferenceDocumentUpload';
    //RDLibraryUpload, ReferenceDocumentUpload, 

    this.analytics.eventWithCustomDimensions('Documents', 'ReferenceDocuments - Web', label, null, customDimensions);
  }

  logRDLGenericEvent(label) {
    const eventAction = !!this.isMobile ? 'ReferenceDocuments - Mobile' : 'ReferenceDocuments - Web';
    this.analytics.event('Documents', eventAction, label);
  }

  /**
   * UNIQUE DOCUMENT LOGGING FUNCTIONS
   */

  /**
   * @param { String } fileType
  */

  logUniqueDocumentUpload() {
    this.analytics.event('Documents', 'UniqueDocuments - Web', 'UniqueDocumentUpload');
  }

  logUniqueDocumentDelete() {
    this.analytics.event('Documents', 'UniqueDocuments - Web', 'UniqueDocumentDeleted');
  }

  logReferenceDocumentDelete() {
    this.analytics.event('Documents', 'ReferenceDocuments - Web', 'ReferenceDocumentDeleted');
  }

  /**
    * CS Analytics
  */
  logCSPhotoActivity(label) {
    const eventAction = !!this.isMobile ? 'CompletionStepEdit - Mobile' : 'CompletionStepEdit - Web';
    this.analytics.event('TaskCompletionStep', eventAction , label);
  }

  logCSCompletion(label) {
    const eventAction = !!this.isMobile ? 'CompletionStep - Mobile' : 'CompletionStep - Web';
    this.analytics.event('TaskCompletionStep', eventAction, label ? label : 'CompletionStepCompleted');
  }

  /**
   * PUSH NOTIFICATIONS
   * @param {string} label - the event label, i.e. 'PushNotificationsOptIn'
   */
  logMobilePushNotification(label) {
    const eventAction = 'Push Notifications - Mobile';
    this.analytics.eventWithCustomDimensions('MobilePushNotifications', eventAction, label, null);
  }

  /**
    * PROJECT TEMPLATE
    */
  logProjectTemplateEvent(projectTemplate, label) {
    this.analytics.projectTemplate = projectTemplate ? projectTemplate.name: null;
    this.analytics.closeoutTemplateType = projectTemplate && projectTemplate.company_closeout_template ? projectTemplate.company_closeout_template.name : null;
    this.analytics.event('ProjectTypesTemplates', 'ProjectTypesTemplates - Web', label);
  }

  /**
   * TEAM FUNCTIONS
   */
  logTeamEvent(label) {
    this.analytics.event('Teams', 'Teams - Web', label);
  }
   /**
   * CLOSEOUT FUNCTIONS
   */
  logCloseoutDocument(label) {
    this.analytics.event('CloseoutDocument', 'CloseoutDocument', label, null);
  }

  logCloseoutNotification(label) {
    this.analytics.event('CloseoutDocument', 'CloseoutDocument - Notification', label, null);
  }

  logCloseoutDocumentEvent(projectTemplate) {
    this.analytics.projectTemplate = projectTemplate ? projectTemplate.name: null;
    this.analytics.closeoutTemplateType = projectTemplate && projectTemplate.company_closeout_template ? projectTemplate.company_closeout_template.name : null;
    if (this.closeoutType == 'build') { this.logCloseoutDocumentEventBuild(); }
    if (this.closeoutType == 'task') { this.logCloseoutDocumentEventTask(); }
    if (this.closeoutType == 'project') { this.logCloseoutDocumentEventProject(); }
  }

  logCloseoutDocumentEventBuild() {
    this.analytics.event('CloseoutDocument', 'CloseoutDocument', 'CloseoutDocumentGeneratedBuild');
  }

  logCloseoutDocumentEventProject() {
    this.analytics.event('CloseoutDocument', 'CloseoutDocument', 'CloseoutDocumentGeneratedProject');
  }

  logCloseoutDocumentEventTask() {
    this.analytics.event('CloseoutDocument', 'CloseoutDocument', 'CloseoutDocumentGeneratedTask');
  }

  logProjectTemplateCloseoutTemplate(projectTemplateName, closeoutTemplateName) {
    const label = closeoutTemplateName == 'Standard' ? 'CloseoutDocumentStandardSelected' : 'CloseoutDocumentCustomSelected';
    this.analytics.projectTemplate = projectTemplateName;
    this.analytics.closeoutTemplateType = closeoutTemplateName;
    this.analytics.event('CloseoutDocument', 'CloseoutDocument', label);
  }

  /**
   * OFFLINE FUNCTIONS
   */
  logOfflineMode(label) {
    this.analytics.event('Session Management', 'OfflineMode - Mobile', label);
  }

  /**
   * USER DASHBOARD FUNCTIONS
   */
  logDashboardEvent(label) {
    const eventAction = !!this.isMobile ? 'UserDashboard - Mobile' : 'UserDashboard - Web';
    this.analytics.event('Dashboard', eventAction, label);
  }

    /**
   * NOTIFICATION FUNCTIONS
   */
  logNotifications(label) {
    const eventAction = !!this.isMobile ? 'Notifications - Mobile' : 'Notifications - Web';
    this.analytics.event('Notifications', eventAction, label);
  }

  /**
   * PROJECT LIST FUNCTIONS
   */
  logProjectListEvent(label) {
    const eventAction = !!this.isMobile ? 'ProjectList - Mobile' : 'ProjectList - Web';
    this.analytics.event('ProjectList', eventAction, label);
  }

  logProjectListFilteringEvent(label) {
    const eventAction = !!this.isMobile ? 'ProjectList - Mobile' : 'ProjectList - Web';
    this.analytics.event('ProjectList', eventAction, 'ProjectListFiltering');
  }

  /**
   * InAppNotifications
   */
  logInAppNotifications(label) {
    const eventAction = !!this.isMobile ? 'InAppNotifications - Mobile' : 'InAppNotifications - Web';
    this.analytics.event('InAppNotifications', eventAction, label);
  }

  /**
   * Maps
   */
  logMaps(label) {
    const eventAction = !!this.isMobile ? 'Maps - Mobile' : 'Maps - Web';
    this.analytics.event('Maps', eventAction, label);
  }

  completeOfflineUpdate(queueItem) {
    this.analytics.event(queueItem.operationKey, queueItem.itemInfo.action, queueItem.itemInfo.label, queueItem.itemInfo.value, queueItem.itemInfo.userTaskAssignment);
    return Promise.resolve(true);
  }

  /**
   * INVENTORY FUNCTIONS
   */
  logInventoryEvent(label) {
    const eventAction = !!this.isMobile ? 'InventoryTracking - Mobile' : 'InventoryTracking - Web';
    this.analytics.event('InventoryTracking', eventAction, label);
  }
  
  /**
   * Manager Dashboard
   */
  logManagerDashboardEvent(label) {
    //labels: UserReportingFiltered, ActivityLogFiltered, ProjectReportingFiltered, ProjectReportingClicked, UserReportingClicked, ActivityLogClicked
    this.analytics.event('Reporting', 'Reporting - Web', label);
  }

    /**
   * Quick Actions
   */
  logProjectMemberAssignment(label, userTaskAssignment) {
    //for build owner and regular quick assigns
    this.analytics.event('QuickAssign', 'QuickAssign - Web', label, null, userTaskAssignment);
  }

  logProjectMemberReplace() {
    this.analytics.event('QuickAssign', 'QuickAssign - Web', 'ProjectMemberReplace');
  }

  logQuickAssignCancel() {
    this.analytics.event('QuickAssign', 'QuickAssign - Web', 'AssignCancel');
  }

  /**
    * TASK ADMINISTRATION
    */
  logTaskAdminEvent(label) {
    const eventAction = !!this.isMobile ? 'TaskAdministration - Mobile' : 'TaskAdministration - Web';
    this.analytics.event('TaskAdministration', eventAction, label);
  }

  /**
    * DELAYS
    */
  logDelayEvent(label, delayType) {
    const eventAction = !!this.isMobile ? 'Delays - Mobile' : 'Delays - Web';
    if (delayType) {
      const customDimensions = {
        'dimension10': delayType,
      };
      this.analytics.eventWithCustomDimensions('Delays', eventAction, label, null, customDimensions);
    }
    else this.analytics.event('Delays', eventAction, label);
  }

  /**
   * PROJECT SPECIFIC
   */
  logProjectEvent(label) {
    const eventAction = !!this.isMobile ? 'Project - Mobile' : 'Project - Web';
    this.analytics.event('Project', eventAction, label);
  }
  
}



// WEBPACK FOOTER //
// ./src/helpers/analytics/analyticsLogger.js